/**
 * Mobile menu
 */
var component_mobile_menu = function (args) {

	// setup args
	let { menu, site, toggles } = args;

	// validate
	if (!menu || !site || !toggles.length) {
		console.log('Invalid mobile_menu args');
		return;
	}

	// setup a11y dialog
	var dialog = new A11yDialog(menu, site);

	// tasks to open menu visually
	var open_menu = function () {

		document.body.classList.add('is-active-menu');

	};

	// tasks to close menu visually
	var close_menu = function () {

		document.body.classList.add('is-closing-menu');
		setTimeout(function () {
			document.body.classList.remove('is-active-menu');
			document.body.classList.remove('is-closing-menu');
		}, 10);

	};

	// hooks
	dialog.on('show', function (element, event) {
		open_menu();
	});
	dialog.on('hide', function (element, event) {
		close_menu();
	});

	// toggle click
	var handle_toggle = function (e) {
		if (document.body.classList.contains('is-active-menu')) {
			dialog.hide();
		} else {
			dialog.show();
		}
	};

	for (var i = 0; i < toggles.length; i++) {
		toggles[i].addEventListener('click', handle_toggle, false);
	}

	// make the call chainable
	return this;

};

/**
 * Init mobile menu
 */
component_mobile_menu({
	menu: document.querySelector('.js-mobile-menu'),
	site: document.querySelector('.js-page'),
	toggles: document.querySelectorAll('.js-menu-toggle'),
});

/**
 * Handle mobile search.
 */
(function () {
	// Search toggle button.
	var search_toggle = document.getElementById('thl-search-toggle');

	// Search input field.
	var search_input = document.getElementById('search-form-input-2');

	// Search wrapper, hidden by default.
	var search_form_wrapper = document.getElementById('thl-mobile-search');

	// Search form (consists of input field and submit button).
	var search_form = document.getElementById('search-form-2');

	// Boolean for determining if focus is inside search form.
	var search_form_has_focus = false;

	search_toggle.addEventListener('click', handle_search_toggle);

	// Handle search toggle clicks.
	function handle_search_toggle() {

		// Get the aria-expanded attribute of the toggle button.
		var expanded = this.getAttribute('aria-expanded') === 'true';

		// Set ARIA attributes, reversing the value of expanded status.
		this.setAttribute('aria-expanded', !expanded);
		this.setAttribute('aria-label', this.getAttribute('data-open-' + !expanded));

		// Show/hide the search form wrapper.
		search_form_wrapper.hidden = expanded;

		if (!expanded) {
			// Move focus to input field when expanding the search wrapper.
			search_input.focus();
		} else {
			search_form_has_focus = false;
		}

	}

	/**
	 * Listen to focus changes in document.
	 * By doing this we can automatically close the search wrapper when focus
	 * moves away from search form.
	 */
	document.addEventListener('focus', function () {

		/**
		 * If user clicks close with mouse directly, focus moves from input to
		 * button. Disregard focus change to prevent search closing and opening
		 * again.
		 */
		if (document.activeElement === search_toggle) {
			return;
		}

		if (search_form.contains(document.activeElement)) {
			search_form_has_focus = true;
		} else if (search_form_has_focus && !search_form.contains(document.activeElement)) {
			search_form_has_focus = false;
			// Imitate clicking the search toggle, effectively closing the search.
			search_toggle.click();
		}
	}, true);

	// Close the search with ESC key.
	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape' && search_form_has_focus ) {
			search_toggle.click();
			search_toggle.focus();
		}
	});

})();

